import React from "react";
import { FaTrash, FaArrowLeft, FaCheck } from "react-icons/fa";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";

import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import "./styles/AdNew.css";
import "./styles/PanelEditAd.css";

import MiniLoader from "../components/MiniLoader";
import AdTip from "../components/AdTip";
import * as actions from "../redux/actions/mediaActions";
import { convertToWebp } from "../utils/imageUtils";
import { getAdId, isImageMedia } from "../utils/adMediaUtils";

class GaleryItem extends React.Component {
  render() {
    return (
      <div className="panel-edit-ad-gallery__item">
        <img
          src={this.props.item.Url}
          className="panel-edit-ad-gallery__img"
          alt="Goder"
        />
        <button
          type="button"
          className="panel-edit-ad-gallery__remove"
          onClick={this.props.onClick}
          aria-label="Remove"
        >
          <FaTrash />
        </button>
      </div>
    );
  }
}

class AdNewGalery extends React.Component {
  state = {
    image: "",
    file: "",
  };

  componentDidMount() {
    this.syncGallery();
  }

  componentDidUpdate(prevProps) {
    const adId = getAdId(this.props.ad);
    const prevAdId = getAdId(prevProps.ad);
    if (adId && adId !== prevAdId) {
      this.syncGallery();
    }
  }

  syncGallery = async () => {
    const adId = getAdId(this.props.ad);
    if (!adId) return;
    await this.fetchMedia(adId);
  };

  fetchMedia = async (adId) => {
    try {
      await this.props
        .LoadMedia(this.props.token, {
          goder_id: adId,
          id: this.props.user_id,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickRemove = async (item) => {
    try {
      await this.props
        .RemoveMedia(this.props.token, {
          media_id: item.Id,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onChangeImageAd = async (e) => {
    const adId = getAdId(this.props.ad);
    if (!adId) {
      alertify.warning(I18n.t("try_later"));
      return;
    }

    if (this.props.mediaList.filter(isImageMedia).length >= 5) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_max_img"), function () {});
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    const webpFile = await convertToWebp(file);
    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        file: webpFile,
        image: reader.result,
      });
    };

    reader.readAsDataURL(webpFile);

    const params = new FormData();
    params.append("goder_id", adId);
    params.append("id", this.props.user_id);
    params.append("image", webpFile);

    try {
      await this.props.UpdateMedia(this.props.token, params);
      if (this.props.error_update) {
        alertify.warning(I18n.t(this.props.error_update));
      } else {
        await this.fetchMedia(adId);
      }
    } catch (error) {
      alertify.warning(I18n.t("try_later"));
    }

    e.target.value = "";
  };

  render() {
    const images = this.props.mediaList.filter(isImageMedia);
    const adName = this.props.ad?.Name;
    const adId = getAdId(this.props.ad);

    return (
      <div className="adnew-page">
        <div className="adnew-page__inner">
          <header className="adnew-page__header">
            <Link to="/goder/menu" className="adnew-page__back" aria-label="Back">
              <FaArrowLeft />
            </Link>
            <div className="adnew-page__heading">
              <h1 className="adnew-page__title">
                <Translate value="img_for_ad" />
              </h1>
              {adName && <p className="adnew-page__subtitle">{adName}</p>}
            </div>
          </header>

          <div className="adnew-page__layout">
            <aside className="adnew-page__sidebar">
              <AdTip />
            </aside>

            <main className="adnew-page__main">
              <section className="panel-edit-ad-card adnew-page__form-card">
                <h2 className="panel-edit-ad-card__title">
                  <Translate value="ad_galery" />
                </h2>

                {!adId && (
                  <p className="panel-edit-ad-gallery__empty">
                    <Translate value="try_later" />
                  </p>
                )}

                {adId && this.props.loading && images.length === 0 && (
                  <div className="panel-edit-ad-gallery__loading">
                    <MiniLoader />
                  </div>
                )}

                {adId && !this.props.loading && images.length > 0 && (
                  <div className="panel-edit-ad-gallery__grid">
                    {images.map((item) => (
                      <GaleryItem
                        item={item}
                        key={item.Id}
                        onClick={() => {
                          this.onClickRemove(item);
                        }}
                      />
                    ))}
                  </div>
                )}

                {adId && !this.props.loading && images.length === 0 && (
                  <p className="panel-edit-ad-gallery__empty">
                    <Translate value="ad_gallery_empty" />
                  </p>
                )}

                {this.props.loading_image && (
                  <div className="adnew-gallery__loader">
                    <MiniLoader />
                  </div>
                )}

                {adId && (
                  <div className="panel-edit-ad-gallery__footer">
                    <Translate value="warning_max_img" />
                    <input
                      className="panel-edit-ad-gallery__upload"
                      accept="image/*"
                      type="file"
                      name="image"
                      id="ad_new_gallery_image"
                      onChange={this.onChangeImageAd}
                    />
                    <label
                      htmlFor="ad_new_gallery_image"
                      className="panel-edit-ad-gallery__upload-btn"
                    >
                      <Translate value="ad_load_image" />
                    </label>
                  </div>
                )}

                <div className="adnew-gallery__actions">
                  <Link to="/home" className="adnew-gallery__finish">
                    <FaCheck />
                    <Translate value="step_finish" />
                  </Link>
                </div>
              </section>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.publish.item,
    mediaList: reducer.media.list,
    loading: reducer.media.loading,
    error: reducer.media.error,
    error_update: reducer.media.error_update,
    loading_image: reducer.media.loadingFile,
  };
}

const mapDispatchToProps = (dispatch) => ({
  RemoveMedia: (token, params) =>
    dispatch(actions.deleteItem({ token, params })),
  UpdateMedia: (token, params) => dispatch(actions.newItem({ token, params })),
  LoadMedia: (token, params) =>
    dispatch(actions.loadList({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdNewGalery);
